"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBackendErrorDetail = void 0;
function getBackendErrorDetail(error) {
    var _a, _b, _c, _d;
    if (typeof ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === 'string') {
        return error.response.data;
    }
    else if (((_b = error.response) === null || _b === void 0 ? void 0 : _b.data.length) > 0) {
        return (_c = error.response) === null || _c === void 0 ? void 0 : _c.data[0];
    }
    else if (typeof ((_d = error.response) === null || _d === void 0 ? void 0 : _d.data) === 'object') {
        return error.response.data.detail;
    }
    else {
        throw new Error('Could not parse Axios error details.');
    }
}
exports.getBackendErrorDetail = getBackendErrorDetail;
//# sourceMappingURL=index.js.map